import { Option } from '../types/common';

export const AMOUNT_FILTER: Option[] = [
  {
    value: 'all',
    label: 'web.balance.deposithistory.filter_all'
  }
];

export const WITHDRAW_AMOUNT_FILTER: Option[] = [
  {
    value: '>=-10',
    label: '<10'
  },
  {
    value: '<=-10',
    label: '>10'
  },
  {
    value: '<=-50',
    label: '>50'
  },
  {
    value: '<=-100',
    label: '>100'
  },
  {
    value: '<=-1000',
    label: '>1000'
  },
  {
    value: '<=-10000',
    label: '>10000'
  }
];

export const DEPOSIT_AMOUNT_FILTER: Option[] = [
  {
    value: '<=10',
    label: '<10'
  },
  {
    value: '>=10',
    label: '>10'
  },
  {
    value: '>=50',
    label: '>50'
  },
  {
    value: '>=100',
    label: '>100'
  },
  {
    value: '>=1000',
    label: '>1000'
  },
  {
    value: '>=10000',
    label: '>10000'
  }
];

export const FILTER_FIELDS = [
  'status',
  'dateOptionId',
  'wallet',
  'amount'
] as const;
